import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getEmitentesCategorias(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmitentesCategoriasPorNivel(context, $codigoEmitenteCategoriaSuperior) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/listarPorNivel", {CODIGO_EMITENTE_CATEGORIA_SUPERIOR: $codigoEmitenteCategoriaSuperior}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },     
    getEmitentesCategoriasBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmitenteCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/obter", {ID_EMITENTE_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    deleteEmitenteCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/excluir", {ID_EMITENTE_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postEmitenteCategoria(context, emitenteCategoria) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesCategorias/access/salvar", emitenteCategoria).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};